<template>
  <div>
    <Card>
      <TablePaginate
        :columns="columns"
        :data="bookings"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, commonButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_bookings_index_226'),
          key: 'code',
          align: 'center',
          width: 200
        },
        {
          title: i18n.t('pages_bookings_index_227'),
          key: 'created_at_str',
          align: 'center',
          width: 180
        },
        {
          title: i18n.t('pages_bookings_index_228'),
          key: 'user_name',
          align: 'center',
          width: 180
        },
        {
          title: i18n.t('pages_bookings_index_229'),
          key: 'fresh_supplier_name',
          width: 260
        },
        {
          title: i18n.t('pages_bookings_index_230'),
          key: 'note'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 230,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(
              commonButtonInTable(
                this,
                h,
                'info',
                i18n.t('pages_bookings_index_231'),
                this.go_to_detail,
                [params.row.id]
              )
            )
            children.push(deleteButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
    this.supplier_index()
  },
  computed: {
    ...mapGetters('booking', ['booking', 'bookings', 'meta', 'loading']),
    ...mapGetters('supplier', ['suppliers'])
  },
  methods: {
    ...mapActions('booking', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapActions('supplier', { supplier_index: 'index' }),
    ...mapMutations('booking', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    go_to_detail (id) {
      this.$router.push(`/cg/${id}/detail`)
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.booking)
      } else if (this.formType === 'new') {
        await this.create(this.booking)
      }
      this.modalShow = false
    }
  }
}
</script>
